import { IChatHeaderProps } from '../types/IChatProps';
import { Avatar, Card } from '@progress/kendo-react-layout';
import OnlineIndicator from './OnlineIndicator';
import UnreadMessageCount from './UnreadMessageCount';

export default function ChatHeader(props: IChatHeaderProps) {
    return (
        <div className='chat-header' onClick={props.onClick}>
            <Card orientation="horizontal" >
                <div className='profile-wrapper'>
                    <Avatar size='medium' type="image" style={{ margin: 5 }}>
                        <img
                            src={props.image ?? './images/placeholder.png'}
                            alt={`profile image`}
                        />
                    </Avatar>
                    {props.uId && <OnlineIndicator Uid={props.uId} />}
                </div>
                <div className="k-vbox">
                    <UnreadMessageCount conversationUid={props.conversationUid} />
                    <h4>{props.header}</h4>
                    {props.subheader && <h5>{props.subheader}</h5>}
                </div>
            </Card>
        </div>
    )
}

// export type ChatHeaderProps = {
//     chat?: IChat,
//     closeChat?:(chat:IChat)=>void
// }